<script>
  import animateScroll from '@/common/js/scroll'

  const HEIGHT = 96
  const OFFSET = 50

  export default {
    name: 'navigation',
    components: {

    },
    filters: {

    },
    mixins: [],
    props: {

    },
    data() {
      return {
        menuList: [],
        menuShow: []
      }
    },
    computed: {

    },
    watch: {

    },
    created() {
      this.menuList.push(
        {
          name: '首页',
          link: 'index.html',
          childs: [
           {
              name: '安途简介',
              id: 'wyjj'
            }
          ]
        }, {
          name: '业务介绍',
          link: 'businessIntr.html',
          childs: [
            {
              name: '服务项目',
              id: 'fwxm'
            }
          ]
        }, {
          name: '信息披露',
          link: 'inforDis.html',
          childs: [
            {
              name: '资质信息',
              id: 'zzxx'
            },
            {
              name: '产品信息',
              id: 'cpxx'
            },
            {
              name: '合作信息',
              id: 'hzxx'
            }
          ]
        }, {
          name: '关于我们',
          link: 'aboutUs.html',
          childs: [
            {
              name: '机构分布',
              id: 'jgfb'
            },
            {
              name: '联系我们',
              id: 'lxwm'
            }
          ]
        }
      )
      this.menuShow.length = this.menuList.length
    },
    mounted() {

    },
    methods: {
      dropdownToggle(index, visible) {
        this.menuShow.splice(index, 1, visible);
      },
      scrollTo(id, link) {
        const regex = /([\s\S]*)\.html/
        const found = link.match(regex)
        const href = location.href
        const index = href.lastIndexOf('/')
        const link2 = href.substring(index + 1, href.length)
        const found2 = link2.match(regex)
        const url = found && found[1]
        const nowUrl = found2 && found2[1]
        if (url !== nowUrl) {
          location.href = `${url}.html#${id}`
        }
        if (!id || !document.getElementById(id)) return
        animateScroll(document.getElementById(id), OFFSET, -HEIGHT)
      }
    }
  }
</script>

<template>
  <div class="header-wrapper">
    <header class="header-fix">
      <div class="inner">
        <h1 class="logo text-hide">安途保险代理
          <a href="index.html" title="安途保险代理">
            <img src="//media.winbaoxian.com/autoUpload/common/logo_232c77c5977a970.png" alt="安途保险代理">
          </a>
        </h1>
        <nav class="menu-wrap">
          <ul class="menu">
            <li class="menu-item"
              v-for="(item, index) in menuList"
              :key="index"
              :class="{'active': menuShow[index]}"
              @mouseenter="dropdownToggle(index, true)"
              @mouseleave="dropdownToggle(index)">
              <a class="active-nav"
                :href="item.link">{{item.name}}</a>
              <div class="dropdown-block">
                <ul class="dropdown-content-menu"
                  v-if="item.childs">
                  <li class="dropdown-item"
                    v-for="c in item.childs"
                    :key="c.id">
                    <a href="javascript:;"
                      @click.stop="scrollTo(c.id, item.link)">{{c.name}}</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  </div>
</template>

<style scoped>
  @import 'variable';

  .header-fix {
    z-index: 100;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    border-bottom: 1px solid #ddd;
    background-color: #fff;
    .inner {
      margin: 0 auto;
      padding: 0 20px;
      width: 1200px;
      background-color: #fff;
      justify-content: space-between;
    }
  }

  .logo {
    /*flex: 300px 0 0;*/
    float: left;
    width: 300px;
    height: 56px;
    padding: 20px 0 19px;
    display: table-cell;
  }

  .menu-wrap {
    /*flex: 500px 0 0;*/
    float: right;
    width: 500px;
    padding-top: 13px;
    display: table-cell;
  }

  .menu {
    /*display: flex;*/
    text-align: center;
    font-size: 16px;
    .menu-item {
      z-index: 1;
      /*flex: 1;*/
      float: left;
      width: 25%;
      position: relative;
    }
    .dropdown-block {
      display: none;
      position: absolute;
      top: 82px;
      left: 0;
      z-index: 1000;
      float: left;
      font-size: 14px;
    }
    .active-nav {
      display: block;
      padding: 25px 0;
      cursor: pointer;
      color: #555;
      &:after {
        content: none;
        position: absolute;
        left: 50%;
        bottom: 20px;
        width: 28px;
        height: 0;
        border-bottom: 1px solid #ea6000;
        margin-left: -14px;
      }
    }
    .active {
      .active-nav {
        color: #ea6000;
        &:after {
          content: '';
        }
      }
      .dropdown-block {
        display: block;
      }
    }
  }

  .dropdown-content-menu {
    border-top: 1px solid #ddd;
    background-color: #fff;
    li {
      width: 120px;
      &:last-child {
        a {
          border-bottom: 1px solid #ddd;
        }
      }
    }
    .dropdown-item {
      a {
        display: block;
        padding: 12px 0;
        border-left: 1px solid #ddd;
        border-right: 1px solid #ddd;
        color: #555;
        &:hover {
          color: #fff;
          background-color: #ea6000;
          border-color: #ea6000;
        }
      }
    }
  }
</style>
